import React, { useEffect, useState, useRef } from 'react';
 import DistExtensionReportFps from './DistExtensionReportFps'; 
 import CircularProgress from '@mui/material/CircularProgress';
 import Box from '@mui/material/Box';

const DistributionAfso_data = async (params) => {

    const response = await fetch(`${process.env.REACT_APP_URL_SIDE}/api/DistExtensionReportOffice`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
    });
    if (!response.ok) {
        throw new Error('Failed to fetch data');
    }
    return response.json();
};

const Distribution_Afso = ({ month, year, dist_code }) => {
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tabHeading, setTabHeading] = useState(null);
    const [renderContenttt, setRenderContenttt] = useState(null);
    const details2 = useRef(null); // Use ref to scroll to this div

    const handleAfsoClick = (month, year, dist_code, afso_code) => {

        setTimeout(() => {
            setRenderContenttt(null);

            setRenderContenttt(
                <DistExtensionReportFps
                    month={month}
                    year={year}
                    dist_code={dist_code}
                    afso_code={afso_code}
                />
            );

        }, 10);
    };


    useEffect(() => {
        const getData = async () => {
            try {
                const response_data = await DistributionAfso_data({ month, year, dist_code });

                setTabHeading(response_data.heading);
                if (response_data.data && response_data.data.length > 0) {
                    setReportData(response_data.data);
                } else {
                    setReportData([]);
                }
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        getData();
    }, [month, year, dist_code]);
    useEffect(() => {
        if (!loading && !error && reportData.length > 0 && details2.current) {
            details2.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [loading, error, reportData]);

    if (loading) {
        return <div style={{display:'flex', justifyContent:'center',alignItems:'center'}}><Box sx={{ display: 'flex'}}>
            <CircularProgress />
        </Box></div>
    }
    if (error) {
        return <div class="mainhead" align="center">
        Internal Error
        </div>
      }
      if (reportData.length === 0) {
          return <div class="mainhead" align="center">
          No data found 
       </div>
        }
    
    return (
        <>
            <table align="center" width="50%" border={1}>
                <thead>
                    <tr className="tableheader">
                        <th colSpan={9}>{tabHeading}</th>
                    </tr>
                    <tr className="tableheader">
                        <th rowSpan={3}>Sl.No</th>
                        <th rowSpan={3}>Office</th> 
                        <th rowSpan={3}>Start Date</th>
                        <th rowSpan={3}>End Date</th>
                    </tr>
                 
                </thead>
                <tbody>
                    {
                             reportData.map((item, index) => (
                                <tr key={item.afso_code}>
                                    <td style={{ textAlign: 'center' }}>{index + 1}</td>
                                    <td style={{ textAlign: 'left' }}>
                                        <a
                                            style={{ cursor: 'pointer', color: 'blue' }}
                                            onClick={() => handleAfsoClick(month, year,  dist_code, item.afso_code)}
                                        >
                                            {item.afso_name_en}
                                        </a>
                                    </td>
                                   <td style={{ textAlign: 'right' }}>{item.startdate}</td>
                                    <td style={{ textAlign: 'right' }}>{item.endDate}</td>

                                </tr>
                            ))  }
              
                </tbody>
            </table>
            <br /><br />
            <div id='detailsRR' ref={details2}>{renderContenttt}</div>
        </>
    );
};

export default Distribution_Afso;
